import { gsap, Sine } from 'gsap'

export const animate = async () => {
    /* CAN ANIMATIONS */
    const randomX = random(1, 10)
    const randomY = random(1, 10)
    const randomDelay = random(0, 1)
    const randomTime = random(3, 5)
    const randomTime2 = random(5, 10)
    // const randomAngle = random(-10, 10)
    const randomAngle = random(-5, 5)


    const cans = document.querySelectorAll('.img-animate')

    cans.length > 0 && Array.from( cans ).map( (can, index) => {
        const odd = index % 2 ? false : true

        gsap.set( can, {
            x: randomX( odd ? -1 : 1 ),
            y: randomY( odd ? 1 : -1 ),
            rotation: randomAngle( odd ? -1 : 1 )
        } )
        moveX( can, odd ? 1 : -1 )
        moveY( can, odd ? -1 : 1 )
        rotate( can, odd ? 1 : -1)
    } )


   function rotate(target:Element, direction:number) {
     gsap.to(target, {
       duration: randomTime2(),
       rotation: randomAngle(direction),
       delay: randomDelay(),
       ease: Sine.easeInOut,
       onComplete: rotate,
       onCompleteParams: [target, direction * -1]
     })
   }

   function moveX(target:Element, direction:number) {
     gsap.to(target, {
       duration: randomTime(),
       x: randomX(direction),
       ease: Sine.easeInOut,
       onComplete: moveX,
       onCompleteParams: [target, direction * -1]
     });
   }

   function moveY(target:Element, direction:number) {
     gsap.to(target, {
       duration: randomTime(),
       y: randomY(direction),
       ease: Sine.easeInOut,
       onComplete: moveY,
       onCompleteParams: [target, direction * -1]
     })
   }

   function random(min:number, max:number) {
     const delta = max - min
     return (direction = 1) => (min + delta * Math.random()) * direction
   }
}
 